import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// A list capped at `limit` items with a "show all" toggle, so long fact lists stay scannable.
export function ExpandableList({ items, render, limit = 5, className = 'space-y-1 text-sm text-gray-700', testId }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  if (!items?.length) return null
  const shown = open ? items : items.slice(0, limit)
  return (
    <div data-testid={testId}>
      <ul className={className}>{shown.map((item, i) => <li key={i}>{render(item)}</li>)}</ul>
      {items.length > limit && (
        <button type="button" className="mt-1 text-xs text-primary-600 underline" onClick={() => setOpen((v) => !v)}>
          {open ? t('cycleReports.health.showLess') : t('cycleReports.health.showAll', { count: items.length })}
        </button>
      )}
    </div>
  )
}

export default ExpandableList
